module.exports = __webpack_public_path__ + "static/media/money-car.1dac7878.jpg";